import React from "react";
import googlePlay from "./GooglePlay.svg";
import googlePlay1 from "./GooglePlay1.svg";
import bookLover from "./book-lover.svg";
import { useState, useEffect } from "react";
import paperFold from "./paper-fold.svg";
import { db } from "../../../firebase_setup/firebase"
import "./hero-section.scss";
import { doc, getDoc } from "firebase/firestore";

const HeroSection = () => {
  async function fetch() {
    const docSnap = await getDoc(docRef);
    if (docSnap) {
      setHeadin(docSnap.data());
    }


    console.log(homeHeading["body"]);
  }

  const [homeHeading, setHeadin] = useState({});
  const docRef = doc(db, "home", "Df6Cg19rXmvT51GvxbfH");
  useEffect(() => {
    fetch();
  });

  return (
    <div className="main-hero-section" id="hero">
      <div className="hero-section">
        <div className="left-hero-section">
          <h1>
            {homeHeading["heading"] ? homeHeading["heading"].substring(0, 3) : ""} <span>{homeHeading["heading"] ? homeHeading["heading"].substring(4, 11) : ""}</span>
          </h1>
          <h1>at your doorstep</h1>
          <p>
            {homeHeading["body"] ? homeHeading["body"] : ""}
          </p>
          <div className="get-started"  onClick={()=>window.location.replace('https://play.google.com/store/apps/details?id=in.freshpage.android')}>
            <input type="text" />
            <button className="button">Get started</button>
          </div>

          <div className="google-play-container" onClick={()=>window.location.replace('https://play.google.com/store/apps/details?id=in.freshpage.android')}>
            <img src={googlePlay} alt="Google Play" />
            <img src={googlePlay1} alt="Google Play" />
          </div>
        </div>
        <div className="right-hero-section">
          <img src={bookLover} alt="Book-lover" />
        </div>
        <div className="paper-fold">
          <img src={paperFold} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
